module.exports = "<span class=\"sequence-success\">\n  <svg aria-hidden=\"true\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n    <path d=\"M16 4.41 14.59 3 6 11.59 2.41 8 1 9.41l5 5 10-10Z\"></path>\n  </svg>\n  {{ data }}\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/snackbars/snackbar-success/snackbar-success.component.html
// module id = ./src/app/shared/snackbars/snackbar-success/snackbar-success.component.html
// module chunks = main